(() => {
  angular
    .module('app')
    .controller(
      'common.views.postHospitalization.details.index',
      GuaranteeLetterDetailPageController
    );

  GuaranteeLetterDetailPageController.$inject = [
    '$state',
    '$stateParams',
    'abp.services.app.postHospitalizationGuaranteeLetter',
    'Hms.ServiceRequests.ServiceRequestType'
  ];

  function GuaranteeLetterDetailPageController(
    $state,
    $stateParams,
    postHospitalizationGuaranteeLetterSvc,
    enumServiceRequestType
  ) {
    const vm = this;

    vm.letterNumber = $stateParams.letterNumber;
    vm.serviceType = $stateParams.serviceType;
    vm.memberId = 0; // For host claim policy component use. Get value from letter detail component.
    vm.isHost = App.isHost();
    vm.isCorporate = App.isCorporate();
    vm.activeTab = _.toInteger($stateParams.tab) || 1;
    vm.isDetailPage = true;
    vm.showCreateQuery = false;
    vm.activeTab = $stateParams.activeTab;

    vm.enums = {};
    vm.enums.serviceRequestType = enumServiceRequestType;

    vm.currencyCode = abp.setting.get('Hms.General.CurrencyCode');

    function init() {
      getLetterDetail();
    }

    function getLetterDetail() {
      vm.loading += 1;
      postHospitalizationGuaranteeLetterSvc
        .getPostHospitalizationGuaranteeLetterDetails({
          id: vm.letterNumber,
        })
        .success((data) => {
          vm.letter = data;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    init();

  }
})();
